import React from 'react';
import { Box, Grid } from '@mui/material';

import TaskCard from 'components/TaskCard';
import TaskCardSkeleton from 'components/TaskCard/TaskCardSkeleton';
import { ViewMoreLink } from 'components/common/ViewMoreLink';
import useMyTasks from 'hooks/MyTasks';
import { MyTasksHeader, SETTING_UP_TASKS_MESSAGE, TASKS_SETUP_FAILED_MESSAGE, Title } from './styles';

const maxTasks = 4;

export const MyTasks = ({ dailySurvey }) => {
  const {
    participantTaskIds,
    numberOfTasks,
    isLoading,
    isSettingUpTasks,
    didTasksSetupFail,
    refetchProfileParticipantTasks,
  } = useMyTasks({
    limit : maxTasks,
  });

  const content = isSettingUpTasks
    ? (
      <Title
        variant='h6' color='textSecondary' paddingLeft={'8px'}>
        {SETTING_UP_TASKS_MESSAGE}
      </Title>
    )
    : isLoading
    ? (
      <>
        <Grid
          item md={6} lg={3} sx={{ flex: 1 }}>
          <TaskCardSkeleton />
        </Grid>
        <Grid
          item md={6} lg={3} sx={{ flex: 1 }}>
          <TaskCardSkeleton />
        </Grid>
        <Grid
          item md={6} lg={3} sx={{ flex: 1 }}>
          <TaskCardSkeleton />
        </Grid>
        <Grid
          item md={6} lg={3} sx={{ flex: 1 }}>
          <TaskCardSkeleton />
        </Grid>
      </>
    )
    : numberOfTasks === 0
      ? (
        <Title
          variant='h6' color='textSecondary' paddingLeft={'8px'}>
          {didTasksSetupFail
            ? TASKS_SETUP_FAILED_MESSAGE
            : 'There are no tasks available. Kindly check back later'}
        </Title>
      )
      : (
        participantTaskIds?.map?.((id) => (
          <Grid
            key={id} item md={6} lg={3} sx={{ flex: 1 }}>
            <TaskCard
              id={id} refetchProfileParticipantTasks={refetchProfileParticipantTasks}
            />
          </Grid>
        ))
      );

  return (
    <Box>
      <MyTasksHeader
        sx={{
          flexDirection : { xs: 'column', md: 'row' },
        }}>
        <Title
          variant='h3'>My tasks</Title>
        {numberOfTasks > maxTasks && (
          <ViewMoreLink
            to={'/my-tasks'}>View all</ViewMoreLink>
        )}
      </MyTasksHeader>
      <Grid
        container
        spacing={1}>
        {content}
      </Grid>
    </Box>
  );
};
